export const cn = (classNames: string | string[]): string => {
  if (typeof classNames === "string") {
    return classNames ? classNames : "";
  } else return classNames.filter((c) => c !== undefined).join(" ");
};
